import { render, staticRenderFns } from "./SharedIdGroupDetails.vue?vue&type=template&id=4afaf0f0&scoped=true&"
import script from "./SharedIdGroupDetails.vue?vue&type=script&lang=js&"
export * from "./SharedIdGroupDetails.vue?vue&type=script&lang=js&"
import style0 from "./SharedIdGroupDetails.vue?vue&type=style&index=0&id=4afaf0f0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afaf0f0",
  null
  
)

export default component.exports